import React from 'react';
import './SubmitButton.css';
import { motion } from 'framer-motion';
import Icon from '../home/Icon';
import Tooltip from '../tooltip/Tooltip';

function SubmitButton({icon = 'person_add', onClick = () => {}, styletype = 'round', type = 3, style={}, tooltip = '', label = '', disabled = false}) {
  const buttonVariants = {
    initial: {
      scale: 1
    },
    hover: {
      scale: 1.02,
      cursor: "pointer"
    },
    click: {
      scale: 0.97,
      transition: {
        duration: 0.01
      }
    }
  }

  const colorClass = type === 1 ? "negative" : type === 2 ? "positive" : type === 3 ? "accent" : '';

  return (
    <motion.button
      type='submit'
      className={`addNew ${label ? 'labeled' : styletype} ${colorClass}`}
      variants={buttonVariants}
      initial="initial"
      whileHover={disabled ? undefined : "hover"}
      whileTap={disabled ? undefined : "click"}
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {label ? (
        <>
          <Icon className="addNewIcon addNewIconSmall" icon={icon} />
          <span className="addNewLabel">{label}</span>
        </>
      ) : (
        <Tooltip text={tooltip}>
          <Icon className={`addNewIcon ${styletype}`} icon={icon} />
        </Tooltip>
      )}
    </motion.button>
  )
}

export default SubmitButton